import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
    createChatCategorie, editChatCategory, seeListChatCategories,
    deleteChatCategorie, removeChatCategorie
} from '../../actions/categoriesActions'
import { Translate } from '../../../language';
import inMemoryJWT from '../../../auth/inMemoryJwt';

const ChatCategorieAdmin = ({ history, createChatCategorie, editChatCategory, listChatCategories, seeListChatCategories, deleteChatCategorie, removeChatCategorie, isLoadingListChatCategories }) => {

    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            seeListChatCategories()
        })

    }, [])


    const [isEdit, setIsEdit] = useState(false)
    const [idEdit, setIdEdit] = useState('')
    const [indexEdit, setIndexEdit] = useState('')
    const [nameCategorie, setNameCategorie] = useState('')
    const [isValidate, setValidate] = useState(false)
    const [error, setError] = useState({})
    const [isEnable, setEnable] = useState(false)

    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }


    const isEmpty = (e) => {
        if (nameCategorie !== '') {
            setValidate(true)
        }
        const { name, placeholder, value } = e.target;
        if (value.length === 0) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }
        if (value.length !== 0) {

            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));
        }

    }


    return (
        <div className="container-mark-type-admin">
            <div className="new-edit-type-mark-container-admin">
                <div className='title-admin'>{`${isEdit ? 'Editar' : 'Nueva'} categoria para salas y zonas`}</div>
                <div className="container-inputs-new-mark">
                    <div className="text-input-admin">
                        {'Nombre:'}
                    </div>
                    <input
                        name='nameCategorie'
                        className='inputs-admin'
                        value={nameCategorie}
                        onChange={(e) => {
                            setNameCategorie(e.target.value.trimStart())
                            if (nameCategorie !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                    <div className="text-error text-error-admin">{error.name}</div>
                    {isEdit ?
                        <div className="content-buttom-create-admin">
                            <button className={`btns-admin btn-create-edit btns-admin-inactive`} onClick={() => {
                                setNameCategorie('')
                                setEnable(false)
                                setIdEdit('')
                                setIndexEdit('')
                                setIsEdit(false)
                            }}>
                                {Translate('cancel', 'es')}
                            </button>
                            <div className="ml-1 mr-1"></div>
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => {
                                    editChatCategory({ name: nameCategorie.trim(), categoryID: idEdit, isEnabled: isEnable }, history, indexEdit)
                                    setNameCategorie('')
                                    setEnable(false)
                                    setIdEdit('')
                                    setIndexEdit('')
                                    setIsEdit(false)
                                }}>
                                {Translate('edit', 'es')}
                            </button>
                        </div>
                        :
                        <div className="content-buttom-create-admin">
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`}
                                onClick={() => {

                                    createChatCategorie({ name: nameCategorie.trim() }, history)
                                    setNameCategorie('')
                                }}>
                                {Translate('create', 'es')}
                            </button>
                        </div>

                    }
                </div>
            </div>
            <div className="see-all-mark-type-admin">
                <div className='title-admin-list'>Categorias existentes</div>
                <div className='wrapper-2 column-gap row-gap mt-3'>
                    {isLoadingListChatCategories ? <div>Cargando...</div> :
                        listChatCategories.map((categorie, index) => (
                            <div key={categorie._id} className="card-admin">
                                <div className="tittle-card-admin">{categorie.name}</div>
                                <div className="column centerContent">
                                    <div className="btns-admin ml-1 mr-1" onClick={() => {
                                        setNameCategorie(categorie.name)
                                        setIdEdit(categorie._id)
                                        setEnable(categorie.isEnable)
                                        setIndexEdit(index)
                                        setIsEdit(true)
                                    }}>Editar</div>
                                    <div className="btns-admin btns-admin-red" onClick={() => { deleteChatCategorie(categorie._id, index) }}>Eliminar</div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        isLoadingListChatCategories: state.socialCategoriesAdmin.isLoadingListChatCategories,
        listChatCategories: state.socialCategoriesAdmin.listChatCategories
    }
}


export default connect(mapStateToProps, { createChatCategorie, editChatCategory, seeListChatCategories, deleteChatCategorie, removeChatCategorie })(ChatCategorieAdmin)